
export const ADULT_COUNT_INCREMENT = "ADULT_COUNT_INCREMENT"
export const ADULT_COUNT_DECREMENT = "ADULT_COUNT_DECREMENT"
export const CHILD_COUNT_INCREMENT = "CHILD_COUNT_INCREMENT"
export const CHILD_COUNT_DECREMENT = "CHILD_COUNT_DECREMENT"

